import NewHeader from "../components_en/NewHeader_dev";
import DownloadCSS from "./Download.module.css";
import Footer from "../components/Footer";
import Loader from '../components/Loader';
import React,{useState,useEffect} from 'react';

function Download() {
  const imagestyle = {
      height: "180px",
      width: "180px",
  };
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  }, []);
  return (
    <div className={DownloadCSS.content}>
      <NewHeader />
      <br />
      <br />
      <div className={DownloadCSS.titletext}>- Applications for Windows -</div>
        <div className={DownloadCSS.imageflex}>
        <a href="/download/windows.zip" download><img src="https://www.smartooth.co/img/download_smartoothservice_windows.png" alt="Smartooth Windows Service" width="230px" /></a>
            <div className={DownloadCSS.userimage1}>
                      <a href="/download/smartooth_windows_20260209_kor.pdf" download><p>사용자 가이드 (한국어)</p></a>
                      <a href="/download/Smartooth_Service_Windows_User Guide_v1.pdf" download><p>User Guide (English)</p></a>
                      <a href="/download/smartooth_windows_20260209_jpn.pdf" download><p>ユーザーガイド (日本語)</p></a>
                  </div>
        </div>
        <div className={DownloadCSS.titletext}>- Applications for Android Tablet -</div>        
        <div className={DownloadCSS.imageflex}>
        <a href="/download/smartooth_dental_hospital.apk" type="application/vnd.android.package-achive" download><img src="https://www.smartooth.co/img/download_dent_eng.png" alt="Smartooth" width="230px" /></a>
            <div className={DownloadCSS.userimage1}>
            <a href="/download/smartooth_dentist_20260212_kor.pdf" download><p>사용자 가이드 (한국어)</p></a>
                      <a href="/download/Smartooth_Dentist_Service_User Guide_v1.pdf" download><p>User Guide (English)</p></a>
                      <a href="/download/smartooth_dentist_20260212_jpn.pdf" download><p>ユーザーガイド (日本語)</p></a>
                  </div>
                  <a href="/download/smartooth_school_service_20240711_1.2.8.apk" type="application/vnd.android.package-achive" download><img src="https://www.smartooth.co/img/download_kinder.png" alt="Smartooth" width="230px" /></a>
            <div className={DownloadCSS.userimage1}>
                  </div>
        </div>
        <div className={DownloadCSS.imageflex}>
        <a href="/download/smartooth_dpapp_20250717.apk" target="_blank" type="application/vnd.android.package-achive" download><img src="https://www.smartooth.co/img/download_dpapp.png" alt="Smartooth" width="230px" /></a>
        <div className={DownloadCSS.userimage1}>
                    <a href="https://apps.apple.com/kr/app/smartooth-dp/id6670414479" target="_blank" download>
                        <p>iOS App Donwload link</p>

                    </a>
                    <a href="https://apps.apple.com/kr/app/smartooth-dp/id6670414479" target="_blank" download>
                        <p>iOS アプリのダウンロードリンク</p>
                        
                    </a>
                  </div>
        <a href="/download/smartooth_phc_service_111_20251104.apk" type="application/vnd.android.package-achive" download><img src="https://www.smartooth.co/img/download_healthcare.png" alt="Smartooth" width="230px" /></a>
            <div className={DownloadCSS.userimage1}>
                  </div>
        </div>
        <div className={DownloadCSS.imageflex}>
        <a href="/download/smartooth_20250915.apk" target="_blank" type="application/vnd.android.package-achive" download><img src="https://www.smartooth.co/img/download_general.png" alt="Smartooth" width="230px" /></a>
        <div className={DownloadCSS.userimage1}>
                      <a href="/download/smartooth_global_20260205_kor.pdf" download><p>사용자 가이드 (한국어)</p></a>
                      <a href="/download/smartooth_global_20260205_jpn.pdf" download><p>ユーザーガイド (日本語)</p></a>
                  </div>
                  <a href="/download/smartooth_school_service_20250513_2.apk" type="application/vnd.android.package-achive" download><img src="https://www.smartooth.co/img/download_school.png" alt="Smartooth" width="230px" /></a>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      <Footer />
    </div>
  );
}
export default Download;